import { render, staticRenderFns } from "./OnboardingFourthStep.vue?vue&type=template&id=4106cad4&scoped=true"
import script from "./OnboardingFourthStep.vue?vue&type=script&lang=js"
export * from "./OnboardingFourthStep.vue?vue&type=script&lang=js"
import style0 from "./OnboardingFourthStep.vue?vue&type=style&index=0&id=4106cad4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4106cad4",
  null
  
)

export default component.exports